import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-complaint-modal',
  templateUrl: './complaint-modal.component.html'
})
export class ComplaintModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
